/*******************************************************************************
 * Copyright (c) 2024 Passport Fintech Inc. All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 ******************************************************************************/

export interface Credentials {
  email?: string;
  password: string;
  accountId?: string;
  loginId?: string;
  product?: string;
}

export interface CredentialsToApi {
  email?: string;
  password: string;
  login_id?: string;
  product?: string;
}

export const credentialsToApiRequest = (request: Credentials): CredentialsToApi => {
  return {
    password: request.password,
    ...(request.email && {email: request.email}),
    ...(request.loginId && {login_id: request.loginId}),
    ...(request.product && {product: request.product}),
  };
};
